import { useConnection, useReadContracts } from 'wagmi';
import { stakingManagerAbi, syntraTimelockAbi } from '@syntra/abi';
import { DEPLOYMENT as D } from '../config/env.ts';
import { CANCELLER_ROLE, PAUSER_ROLE, PROPOSER_ROLE } from '../lib/admin.ts';

/**
 * The connected wallet's governance roles: proposer on the timelock (schedules and executes changes), pauser (the
 * emergency switch) and canceller (the veto: it can stop a scheduled change). `admin` is proposer or pauser; a
 * wallet that only holds the veto is not an admin but sees the Admin page's queue. All false while disconnected or
 * still loading.
 */
export function useIsAdmin() {
  const { address } = useConnection();
  const roles = useReadContracts({
    allowFailure: false,
    query: { enabled: Boolean(address) },
    contracts: [
      { address: D.timelock, abi: syntraTimelockAbi, functionName: 'hasRole', args: [PROPOSER_ROLE, address!] },
      { address: D.staking, abi: stakingManagerAbi, functionName: 'hasRole', args: [PAUSER_ROLE, address!] },
      { address: D.timelock, abi: syntraTimelockAbi, functionName: 'hasRole', args: [CANCELLER_ROLE, address!] },
    ],
  });
  const [proposer, pauser, canceller] = address && roles.data ? roles.data : [false, false, false];
  return { proposer, pauser, canceller, admin: proposer || pauser || canceller };
}
